import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex } from '@modusign/design-system';

import HelpButtonTooltip from './HelpButtonTooltip';
import QuestionCircleIcon from './QuestionCircleIcon';

interface HelpButtonProps {
  variant: 'basic' | 'dark' | 'darkIcon';
  onClick?: () => void;
}

const defaultProps = {
  variant: 'basic',
};

function HelpButton({ variant, onClick }: HelpButtonProps) {
  if (variant === 'darkIcon') {
    return (
      <Flex
        alignItems="center"
        aria-label="도움말"
        as="button"
        borderRadius="4px"
        className="tagHelpButton"
        color="textNeutralLightest"
        height="44px"
        justifyContent="center"
        position="relative"
        sx={{
          '& .HelpButton__tooltip': {
            display: 'none',
            left: '50%',
            position: 'absolute',
            textAlign: 'center',
            top: '50px',
            width: '60px',
            padding: 2,
          },
          '&:hover': {
            backgroundColor: 'darkGray600',
            '& .HelpButton__tooltip': {
              display: 'block',
            },
          },
        }}
        type="button"
        width="44px"
        onClick={onClick}
      >
        <QuestionCircleIcon />
        <HelpButtonTooltip className="HelpButton__tooltip" />
      </Flex>
    );
  }

  return (
    <Flex
      alignItems="center"
      aria-label="도움말"
      as="button"
      className="tagHelpButton"
      height="32px"
      justifyContent="center"
      ml={4}
      sx={{
        color: variant === 'basic' ? 'iconNeutralSlightlyDark' : 'textNeutralUltraLight',
        '&:hover': {
          color: variant === 'basic' ? 'iconNeutralVeryDark' : 'textNeutralLightest',
          backgroundColor: 'buttonBackgroundNeutralSlightlyDark',
          borderRadius: '100px',
        },
      }}
      width="32px"
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faQuestionCircle} style={{ width: '18px', height: '18px' }} />
    </Flex>
  );
}

HelpButton.defaultProps = defaultProps;

export default HelpButton;
